export const INSTANCES_MIN = 0;
export const MAX_AD_POD_DURATION_MIN = 0;
const options = {
  OPTION1: 'option1',
  OPTION2: 'option2',
  OPTION3: 'option3',
};

/**
 * checking if the value is a number / array / is the value correct.
 */
const isNumber = value => !Number.isNaN(Number.parseFloat(value));
const isInteger = value => new RegExp('^-?[0-9]+$').test(value);
const isDefined = value => value !== undefined;
const isArray = value => typeof value === 'object';
const isGreaterOrEqual = (value, min) => value >= min;
const isGreater = (value, min) => value > min;

/**
 * validation for midrolls and overlays
 * @param {object} settings
 * @param {string} type
 * @param {string} selectedOption
 */
const validateMidrollsAndOverlay = (settings, type, selectedOption) => {
  const { instances, maxAdPodDuration, interval, percents, timecodes } = settings;
  const areInstancesInteger = isInteger(instances);
  const areInstancesDefined = isDefined(instances);
  const areInstancesGreaterOrEqualThanMinValue = isGreaterOrEqual(instances, INSTANCES_MIN);
  const areInstancesValid =
    areInstancesInteger && areInstancesDefined && areInstancesGreaterOrEqualThanMinValue;
  const isAdPodMaxDurationNumber = isNumber(maxAdPodDuration);
  const isAdPodMaxDurationGreaterOrEqualThanMinValue = isGreaterOrEqual(
    maxAdPodDuration,
    MAX_AD_POD_DURATION_MIN
  );
  const isAdPodMaxDurationValid =
    type === 'overlays'
      ? true
      : isAdPodMaxDurationNumber && isAdPodMaxDurationGreaterOrEqualThanMinValue;

  if (!areInstancesValid || !isAdPodMaxDurationValid) return false;

  /**
   * checking which option is selected and correct
   * @param {number} interval
   * @param {number} percents
   * @param {string} timecodes
   */
  let adBreakPositionisDefined = false;
  switch (selectedOption) {
    case options.OPTION1:
      adBreakPositionisDefined = validateInterval(interval);
      break;
    case options.OPTION2:
      adBreakPositionisDefined = validatePercent(percents);
      break;
    case options.OPTION3:
      adBreakPositionisDefined = validateTimecode(timecodes);
      break;
    default:
      adBreakPositionisDefined =
        validateInterval(interval) || validatePercent(percents) || validateTimecode(timecodes);
      break;
  }

  const isEveryThingIsValid =
    areInstancesValid && isAdPodMaxDurationValid && adBreakPositionisDefined;
  if (isEveryThingIsValid) return true;
};

/**
 * validation for prerolls and postrolls
 * @param {object} settings
 */
const validatePrerollsOrPostrolls = settings => {
  const { instances, maxAdPodDuration } = settings;
  const areInstancesInteger = isInteger(instances);
  const areInstancesDefined = isDefined(instances);
  const areInstancesGreaterOrEqualThanMinValue = isGreaterOrEqual(instances, INSTANCES_MIN);
  const areInstancesValid =
    areInstancesInteger && areInstancesDefined && areInstancesGreaterOrEqualThanMinValue;
  const isAdPodMaxDurationNumber = isNumber(maxAdPodDuration);
  const isAdPodMaxDurationGreaterOrEqualThanMinValue = isGreaterOrEqual(
    maxAdPodDuration,
    MAX_AD_POD_DURATION_MIN
  );
  const isAdPodMaxDurationValid =
    isAdPodMaxDurationNumber && isAdPodMaxDurationGreaterOrEqualThanMinValue;

  if (!areInstancesValid || !isAdPodMaxDurationValid) {
    return false;
  } else {
    return true;
  }
};

/**
 * function for checking the validity of timecodes
 */
function isTimecodesValidate(value) {
  let result = true;

  if (value) {
    value.forEach(item => {
      let duration = -1,
        tmp;

      if (isNumber(item)) {
        return false;
      }

      item = item.trim();

      let timecodesValidationRegex =
        item !== '' &&
        !item.match(/[^0-9|.|:]|\.(:)|:(\.)|:(:)|^\D|\D$/) &&
        (item.lastIndexOf('.') < 0 || item.lastIndexOf('.') > item.lastIndexOf(':')) &&
        (!item.match(/\./g) || (item.match(/\./g) && item.match(/\./g).length < 2)) &&
        (!item.match(/:/g) || (item.match(/:/g) && item.match(/:/g).length < 3));

      if (timecodesValidationRegex) {
        duration = Number.parseInt(item, 10);
        tmp = item.match(/(\d+):(\d+):(\d+)/);
        if (tmp) {
          duration =
            Number.parseInt(tmp[1], 10) * 3600 +
            Number.parseInt(tmp[2], 10) * 60 +
            Number.parseInt(tmp[3], 10);
        } else {
          tmp = item.match(/(\d+):(\d+)/);
          if (tmp) {
            duration = Number.parseInt(tmp[1], 10) * 60 + Number.parseInt(tmp[2], 10);
          }
        }
        tmp = item.match(/(\.\d+)/);
        if (tmp) {
          duration += Number.parseFloat(tmp[1], 10);
        }
      }
      if (duration === -1 || duration < 0) {
        result = false;
      } else {
        result = true;
      }
    });
  }

  return result;
}

/**
 * methods which check if interval / percent / timecode is valid (correct)
 * @param {number} interval
 * @param {number} percents
 * @param {string} timecodes
 */
export const validateInterval = interval => {
  return (
    isNumber(interval) && interval !== null && isGreaterOrEqual(interval, 0) && isDefined(interval)
  );
};
export const validatePercent = percents => {
  return (
    percents &&
    isArray(percents) &&
    percents.length > 0 &&
    percents &&
    percents.every(x => isGreater(Number.parseFloat(x), 0))
  );
};
export const validateTimecode = timecodes => {
  return timecodes && isArray(timecodes) && timecodes.length > 0 && isTimecodesValidate(timecodes);
};

/**
 * method that checks what type of advertising is- in order to trigger a specific validation method
 * @param {object} settings
 * @param {string} type
 * @param {string} selectedOption
 */
export const validate = (settings, type, selectedOption) => {
  if (settings) {
    if (type === 'midrolls' || type === 'overlays') {
      return validateMidrollsAndOverlay(settings, type, selectedOption);
    } else if (type === 'postrolls' || type === 'prerolls') {
      return validatePrerollsOrPostrolls(settings);
    } else {
      throw new Error('incorrect type when calling validate');
    }
  } else {
    return true;
  }
};
